import React from 'react';
import '../../styles/Footer.scss';

const Footer = () => {
  return (
    <div id="footer" className='footerStyle'>
      <div>
        <p className='muted credit creditStyle'>
          © 2020 Brighter.com
        </p>
        <div className='muted credit creditStyle'>
          Trademarks and logos are the property of their respective owners.
          <div>
            <a href="https://providers.brighter.com/#/terms" target='_blank'  rel="noreferrer" className='linkStyle'>Terms and Conditions</a> | 
            <a href="https://providers.brighter.com/#/privacy" target='_blank' rel="noreferrer" className='linkStyle'> Privacy Policy</a>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Footer
